export function flatten(arr, result = []) {
  for (let i = 0, length = arr.length; i < length; i++) {
    const value = arr[i]
    if (Array.isArray(value)) {
      flatten(value, result)
    } else {
      result.push(value)
    }
  }
  return result
}

export const everyNth = (array, nth) => {
  if (array.length <= 200) {
    return array
  }

  return array.filter((e, i) => i % nth === nth - 1)
}

export function union(left, right) {
  const mergedArray = [...left, ...right]
  let set = new Set()
  let unionArray = mergedArray.filter(item => {
    if (!set.has(item.id)) {
      set.add(item.id)
      return true
    }
    return false
  }, set)

  return unionArray
}
